import { render, staticRenderFns } from "./Trx.vue?vue&type=template&id=6577cda8"
import script from "./Trx.vue?vue&type=script&lang=js"
export * from "./Trx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports